module.exports = __webpack_public_path__ + "img/b-title-bg.cd0224bb.png";